<template>
	<div class="sum">
		<div class="info">
			<div class="line">
				<span>Subtotal:</span><span>{{price(subtotal_price)}}</span>
			</div>
			<div class="line">
				<span>Moms:</span><span>{{price(total_tax)}}</span>
			</div>
			<div class="line">
				<span>Fragt:</span><span>{{price(total_shipping_price)}}</span>
			</div>
			<div class="line total">
				<span>Total inkl. moms:</span><span>DKK&nbsp;&nbsp;&nbsp;{{price(total_price)}}</span>
			</div>
		</div>
	</div>
</template>

<script>
import {price} from "@/modules/utils";

export default {
	props: {
		total_tax: {type: Number, required: true},
		total_price: {type: Number, required: true},
		subtotal_price: {type: Number, required: true},
		total_shipping_price: {type: Number, required: true},
	},
	methods: {price}
};
</script>

<style lang="scss" scoped>
.sum {
	text-align: right;
	display: flex;
	justify-content: flex-end;

	.info {
		max-width: 100%;
		width: 500px;

		@include res(xsmall) {
			font-size: 0.85em;
			width: 100%;
			margin-top: 1em;
		}

		.line {
			margin-bottom: 0.6em;
			display: flex;
			justify-content: space-between;
			align-items: center;

			&:nth-child(-n+3) {
				span {
					&:first-child {
						color: #A3AAB0;
					}
				}
			}

			&.total {
				margin-top: 30px;

				span {
					&:last-child {
						font-size: 1.3em;
						font-weight: 500;
					}
				}
			}
		}
	}
}
</style>
